function generateUUIDv1Like() {
    const now = Date.now();

    // Временная метка (первые 8 символов)
    const timeLow = now.toString(16).padStart(8, '0').slice(-8);

    // Случайные части, имитирующие структуру UUID
    const timeMid = Math.random().toString(16).slice(2, 6);
    const timeHigh = '1' + Math.random().toString(16).slice(2, 4); // Начинается с 1 (версия)
    const clockSeq = 'a' + Math.random().toString(16).slice(2, 4); // Начинается с a/b/8/9
    const node = Math.random().toString(16).slice(2, 12).padEnd(10, '0');

    return `${timeLow}-${timeMid}-${timeHigh}-${clockSeq}-${node}`;
}

export function getUUID(){

    const existingUUID = localStorage.getItem('session_uuid');

    if (!existingUUID) {
        // Если session_uuid нет, генерируем новый и сохраняем
        const newUUID = generateUUIDv1Like();
        localStorage.setItem('session_uuid', newUUID);
        return newUUID
    }
    return existingUUID
}